import React, { useEffect, useState, useMemo } from "react";
import {
  Breadcrumbs,
  Link,
  Typography,
  List,
  ListItem,
} from "@material-ui/core";
import { HomeOutlined } from "@material-ui/icons";
import { useLocation, useHistory } from "react-router-dom";
import BacktoHomeBtn from "../components/commons/BacktoHomeBtn";
import useStyles from "../styles/accountCenterStyle.js";
import { useTranslation } from "../langs/useTranslation";
import AnnouncementTable from "../components/Announcement/AnnouncementTable";
import TermTable from "@/components/Announcement/TermTable";

const Announcement = () => {
  const location = useLocation();
  const history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation("devicesGroups");
  const initIndex = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const index = searchParams.get('index') || 0;
    return Number(index)
  }, [])
  const [selectedIndex, setSelectedIndex] = useState(initIndex);

  const drawer = (
    <div>
      <div className={classes.toolbar} />
      <BacktoHomeBtn />
      {/* <Divider /> */}
    </div>
  );

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const index = searchParams.get('index');
    if (index) {
      setSelectedIndex(Number(index || 0))
    }
  }, [location.search])

  return (
    <div className={classes.root}>
      <div className={classes.tabContainer}>
        <List component="div">
          <ListItem 
            button 
            className={classes.itemNav}
            selected={0===selectedIndex} 
            onClick={() => {
              history.push("/announcement?index=0")
              // setSelectedIndex(0)
            }}
          >
            {t({ defaultMessage: "公告管理" })}
          </ListItem>
          <ListItem 
            button 
            className={classes.itemNav} 
            selected={1===selectedIndex} 
            onClick={() => {
              history.push("/announcement?index=1")
              // setSelectedIndex(1)
            }}
          >
            {t({ defaultMessage: "条款管理" })}
          </ListItem>
        </List>

      </div>
      <main className={classes.announcementList}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" href="/">
            <HomeOutlined />
            {t({ defaultMessage: "首页" })}
          </Link>
          <Typography color="textPrimary">
            {selectedIndex===0? t({ defaultMessage: "公告管理" }): t({ defaultMessage: "条款管理" })}
          </Typography>
        </Breadcrumbs>
        { selectedIndex === 0?(
            <>
              <div className={classes.titleSection}>
                <Typography variant="h4">{t({ defaultMessage: "公告管理" })}</Typography>
              </div>
              <AnnouncementTable />
            </>
          ):(
            <>
              <div className={classes.titleSection}>
                <Typography variant="h4">{t({ defaultMessage: "条款管理" })}</Typography>
              </div>
              <TermTable />
            </>
        )}
      </main>
    </div>
  );
};

export default Announcement;
